import React from 'react'
import { connect } from "react-redux";
import { SetDepositPayments_CC } from '$Deposits/store/actions/DepositPost'
import { SetDepositCardNumber_CC, SetDepositCardPIN_CC } from '$Deposits/store/actions/DepositAction'
import { CC_Submit } from '$Deposits/store/actions/DepositEvent'



class CC extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {

        const {
            SetDepositPayments_CC,
            DepositSuccessPage,
            SetDepositCardPIN_CC,
            SetDepositCardNumber_CC,
            DepositCardPIN_CC,
            DepositCardNumber_CC,
            MoneyInput,
            InputNumber,
            InputPin,
            SubmitBtn,
            SuccessPage,
        } = this.props
        const { PINErrMsg, PIN } = DepositCardPIN_CC || {}
        const { numberErrMsg, number } = DepositCardNumber_CC || {}


        return (

            <>
            {!DepositSuccessPage && 
            <>
                <MoneyInput />
                <InputNumber
                    title={'Số SERI Thẻ Cash'}
                    stateVal={numberErrMsg}
                    value={number}
                    placeholder={'Vui lòng nhập số SERI'}
                    onChange={(value) => { SetDepositCardNumber_CC(value) }}
                    maxLength={16}
                    keyboardType='number-pad'
                />
                <InputPin
                    title={'Số PIN Thẻ Cash'}
                    stateVal={PINErrMsg}
                    value={PIN}
                    placeholder={'Vui lòng nhập số PIN'}
                    onChange={(value) => { SetDepositCardPIN_CC(value) }}
                    maxLength={10}
                    keyboardType='number-pad'
                    password={true}
                />
                <SubmitBtn
                    submitBtn={CC_Submit}
                    onPress={() => { SetDepositPayments_CC() }}
                    submitBtnItem={'Chuyển'}
                />
            </>}
                {
                    DepositSuccessPage &&
                    <SuccessPage />
                }
            </>
        );
    }
}

const mapStateToProps = state => ({
    DepositSuccessPage: state.DepositSuccessPage,
    DepositNextStep: state.DepositNextStep,
    DepositCardNumber_CC: state.DepositCardNumber_CC,
    DepositCardPIN_CC: state.DepositCardPIN_CC,
});
const mapDispatchToProps = {
    SetDepositPayments_CC: (data) => SetDepositPayments_CC(data),
    SetDepositCardNumber_CC: (data) => SetDepositCardNumber_CC(data),
    SetDepositCardPIN_CC: (data) => SetDepositCardPIN_CC(data),
};
export default connect(mapStateToProps, mapDispatchToProps)(CC);



